import { customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@customAttribute('collapse-on-click')
export class SplitPaneCollapseOnClick implements EventListenerObject {
  constructor(private root: Element) { }

  private divider: HTMLElement;
  private pointerDown: boolean;
  private dragged: boolean;
  private collapsedTargetFlexBasis: string;
  private collapsedSiblingFlexBasis: string;

  @bindable
  target: 'prev' | 'next' = 'next';

  get targetSibling() {
    return this.target === 'next' ? 'prev' : 'next';
  }

  attached() {
    this.divider = this.root.querySelector('split-pane-divider');
    if (!this.divider) {
      return;
    }

    this.divider.addEventListener('pointerdown', this);
    this.divider.addEventListener('pointerup', this);
    this.divider.addEventListener('pointermove', this);
  }

  handleEvent(e: Event): void {
    switch (e.type) {
      case 'pointerdown':
        this.pointerDown = true;
        this.dragged = false;
        break;
      case 'pointermove':
        this.dragged = this.pointerDown;
        break;
      case 'pointerup':
        if (!this.dragged) {
          const target = this.target === 'next' ? this.divider.nextElementSibling as HTMLElement : this.divider.previousElementSibling as HTMLElement;
          const targetSibling = this.target === 'next' ? this.divider.previousElementSibling as HTMLElement : this.divider.nextElementSibling as HTMLElement;
          if (target.style.flexBasis !== '0px') {
            this.collapsedTargetFlexBasis = target.style.flexBasis;
            this.collapsedSiblingFlexBasis = targetSibling.style.flexBasis;
            target.style.flexBasis = '0px';
            targetSibling.style.flexBasis = '';
          } else {
            target.style.flexBasis = this.collapsedTargetFlexBasis;
            targetSibling.style.flexBasis = this.collapsedSiblingFlexBasis;
          }
        }
        break;
    }
  }
}
